var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5039,
    r: 17.35,
    transform: "rotate(-180 17.5 17.5039)",
    stroke: "#364A5E",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5061 18.7326L8.5061 15.9982C8.5061 15.547 8.87524 15.1779 9.32642 15.1779L17.2561 15.1779L17.2561 10.5978C17.2561 9.86635 18.1379 9.50405 18.6575 10.0167L25.425 16.7843C25.7463 17.1056 25.7463 17.6251 25.425 17.9464L18.6575 24.714C18.1379 25.2335 17.2561 24.8644 17.2561 24.133V19.5529L9.32642 19.5529C8.87524 19.5529 8.5061 19.1837 8.5061 18.7326Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.b5c718477d221aaf16271d7f55afd739.svg";
export { ForwardRef as ReactComponent };